// Wait for the DOM to be fully loaded
gsap.registerPlugin(ScrollTrigger);


const query = document.querySelector.bind(document);
const queryAll = document.querySelectorAll.bind(document);
const heroIconConveyorTL = gsap.timeline({ paused:true });
const heroLogosTL = gsap.timeline({ paused:true });
const heroItemsTL = gsap.timeline({ paused:true });

let currHighlight = -1;

document.addEventListener('DOMContentLoaded', function() {
    if( query('.hero-block') ) {
        initHeroAnimation();
    }

    if( query( '.highlights-block' )) {
        initHighlightsBlock();
    }

    if (query( '.sales-banner-container') ) {
        initSalesBanner();
    }

    if( query( '.leadership-block' ) ) {
        initLeadershipBlock();
    }

    if( query('.modal-overlay') ) {
        query('.modal-overlay .modal-background').addEventListener('click', () => {
            closeModal();
        });
        query('.modal-overlay .close-modal').addEventListener('click', () => {
            closeModal();
        });
    } 

    initMenu();  
}); 

function initHeroAnimation() {
    const heroBlock = query('.hero-block');
    const gearAnimation = heroBlock.querySelector('.gear-animation');
    const bigcog = gearAnimation.querySelector('.big-cog'   );
    const smallcog = gearAnimation.querySelector('.cog');
    const conveyor = heroBlock.querySelector('.conveyor-belt .belt');
    const youtube = heroBlock.querySelector('.youtube');
    const sprecker = heroBlock.querySelector('.sprecker');
    const spotify = heroBlock.querySelector('.spotify');
    const patreon = heroBlock.querySelector('.patreon');
    const apple = heroBlock.querySelector('.apple');
    const mightynetworks = heroBlock.querySelector('.mightynetworks');
    const item01 = heroBlock.querySelector('.item01');
    const item02 = heroBlock.querySelector('.item02');
    const item03 = heroBlock.querySelector('.item03');
    const item04 = heroBlock.querySelector('.item04');
    item01.icon = item01.querySelector('.inner');
    item02.icon = item02.querySelector('.inner');
    item03.icon = item03.querySelector('.inner');
    item04.icon = item04.querySelector('.inner');
    
    
    youtube.icon = youtube.querySelector('.icon');
    spotify.icon = spotify.querySelector('.icon');
    sprecker.icon = sprecker.querySelector('.icon');
    patreon.icon = patreon.querySelector('.icon');
    apple.icon = apple.querySelector('.icon');
    mightynetworks.icon = mightynetworks.querySelector('.icon');
    
    gsap.set( [ spotify.icon, sprecker.icon, patreon.icon, apple.icon, mightynetworks.icon] , {y:"+=15" , scale:0 , transformOrigin: 'center'} ); 
    gsap.set( youtube.icon, {y:"+=15" , scale:0 , transformOrigin: 'center'} ); 
    gsap.set( mightynetworks , {alpha:0} ); // hide mighty networks for now //
    
    heroIconConveyorTL.add( 'start' , 0 );
    heroIconConveyorTL.to( bigcog , 8 , {transformOrigin:'center', rotation:'+=360', ease:'none', repeat:-1}, 'start+=0' );
    heroIconConveyorTL.to( smallcog , 9 , {transformOrigin:'center', rotation:'-=360', ease:'none', repeat:-1}, 'start+=0' );
    heroIconConveyorTL.to( conveyor, 1 , { strokeDashoffset:-33, ease:'none', repeat:-1}, 'start+=0' );

    heroLogosTL.add( 'start' , 0 );

    heroLogosTL.add( "frame01" , "start+=0" );
    heroLogosTL.fromTo(youtube, 5, { x: -20 }, { x: 210, ease: 'none' }, 'frame01+=0');
    heroLogosTL.to( youtube.icon, 1 , {y:"-=10" , scale:1 , transformOrigin:'center', ease:Elastic.easeOut.config(0.8,1) } , 'frame01+=0');
    heroLogosTL.to( youtube.icon, 1 , {y:"+=10" , scale:0 , transformOrigin:'center', ease:Elastic.easeIn.config(0.8,1) } , 'frame01+=3');
    
    heroLogosTL.fromTo(spotify, 5, { x: -20 }, { x: 210, ease: 'none' }, 'frame01+=1.3');
    heroLogosTL.to(spotify.icon, 1 , { y:"-=10" , scale:1 , transformOrigin:'center', ease:Elastic.easeOut.config(0.8,1) } , 'frame01+=1.3');
    heroLogosTL.to(spotify.icon, 1, { y: "+=10", scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) } , 'frame01+=4.3');
    
    heroLogosTL.fromTo(sprecker, 5, { x: -20 }, { x: 210, ease: 'none' }, 'frame01+=2.3');
    heroLogosTL.to(sprecker.icon, 1, { y: "-=10", scale:1 , transformOrigin: 'center', ease: Elastic.easeOut.config(0.8, 1) }, 'frame01+=2.3');
    heroLogosTL.to(sprecker.icon, 1, { y: "+=10", scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) }, 'frame01+=5.3');

    heroLogosTL.fromTo(patreon, 5, { x: -20 }, { x: 210, ease: 'none' }, 'frame01+=3.3');
    heroLogosTL.to(patreon.icon, 1, { y: "-=10", scale:1 , transformOrigin: 'center', ease: Elastic.easeOut.config(0.8, 1) }, 'frame01+=3.3');
    heroLogosTL.to(patreon.icon, 1, { y: "+=10", scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) }, 'frame01+=6.3');

    heroLogosTL.fromTo(apple, 5, { x: -20 }, { x: 210, ease: 'none' }, 'frame01+=4.3');
    heroLogosTL.to(apple.icon, 1, { y: "-=10", scale:1 , transformOrigin: 'center', ease: Elastic.easeOut.config(0.8, 1) } , 'frame01+=4.3');
    heroLogosTL.to(apple.icon, 1, { y: "+=10", scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) }, 'frame01+=7.3');

    heroLogosTL.add("frame02", "frame01+=5.6");
    heroLogosTL.fromTo(youtube, 5, { x: -20 }, { x: 205, ease: 'none' }, 'frame02+=0');
    heroLogosTL.to(youtube.icon, 1, { y: "-=10", scale: 1, transformOrigin: 'center', ease: Elastic.easeOut.config(0.8, 1) }, 'frame02+=0');
    heroLogosTL.to(youtube.icon, 1, { y: "+=10", scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) }, 'frame02+=3');

    heroLogosTL.add("loop", "frame02+=1.3");
    heroLogosTL.fromTo(spotify, 5, { x: -20 }, { x: 210, ease: 'none' }, 'frame02+=1.3');
    heroLogosTL.to(spotify.icon, 1, { y: "-=10", scale: 1, transformOrigin: 'center', ease: Elastic.easeOut.config(0.8, 1) }, 'frame02+=1.3');
    heroLogosTL.to(spotify.icon, 1, { y: "+=10", scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) }, 'frame02+=4.3');

    heroLogosTL.fromTo(sprecker, 5, { x: -20 }, { x: 210, ease: 'none' }, 'frame02+=2.3');
    heroLogosTL.to(sprecker.icon, 1, { y: "-=10", scale: 1, transformOrigin: 'center', ease: Elastic.easeOut.config(0.8, 1) }, 'frame02+=2.3');
    heroLogosTL.to(sprecker.icon, 1, { y: "+=10", scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) }, 'frame02+=5.3');

    heroLogosTL.fromTo(patreon, 5, { x: -20 }, { x: 210, ease: 'none' }, 'frame02+=3.3');
    heroLogosTL.to(patreon.icon, 1, { y: "-=10", scale: 1, transformOrigin: 'center', ease: Elastic.easeOut.config(0.8, 1) }, 'frame02+=3.3');
    heroLogosTL.to(patreon.icon, 1, { y: "+=10", scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) }, 'frame02+=6.3');

    heroLogosTL.fromTo(apple, 5, { x: -20 }, { x: 210, ease: 'none' }, 'frame02+=4.3');
    heroLogosTL.to(apple.icon, 1, { y: "-=10", scale: 1, transformOrigin: 'center', ease: Elastic.easeOut.config(0.8, 1) }, 'frame02+=4.3');
    heroLogosTL.to(apple.icon, 1, { y: "+=10", scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) }, 'frame02+=7.3');

    heroLogosTL.add("frame03", "frame02+=5.6");
    heroLogosTL.fromTo(youtube, 5, { x: -20 }, { x: 205, ease: 'none' }, 'frame03+=0');
    heroLogosTL.to(youtube.icon, 1, { y: "-=10", scale: 1, transformOrigin: 'center', ease: Elastic.easeOut.config(0.8, 1) }, 'frame03+=0');
    heroLogosTL.to(youtube.icon, 1, { y: "+=10", scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) }, 'frame03+=3');

    heroLogosTL.add( ()=>{ heroLogosTL.seek("loop"); } , "frame03+=1.3" );

    heroItemsTL.add( "start" , "+=0" );

    heroItemsTL.add( "frame01" , "start+=0" );
    heroItemsTL.fromTo(item01, 5, { x: -20, y:0 , rotation: -10 , transformOrigin: 'center', } , { transformOrigin: 'center', x: 150 , y: -20 , rotation: 10, ease: 'none' } , "frame01+=0" );
    heroItemsTL.fromTo(item01 , 1 , {scale:0 , transformOrigin: 'center'} , { transformOrigin: 'center', scale:1 , ease:Elastic.easeOut.config(0.8,1)} , "frame01+=1.4" );
    //heroItemsTL.fromTo(item01.icon , 1 , {scale:0 , transformOrigin: 'center'} , { transformOrigin: 'center', scale:1 , ease:Elastic.easeOut.config(0.8,1)} , "frame01+=1.5" );
    heroItemsTL.to(item01 , 1 , {scale:0 , transformOrigin:'center' , ease:Elastic.easeIn.config(0.8,1) } , "frame01+=4" );

    heroItemsTL.add("frame02", "frame01+=1.5");
    heroItemsTL.fromTo(item02, 5, { x: -20, y: 0, rotation: -10, transformOrigin: 'center', }, { transformOrigin: 'center', x: 120, y: 20, rotation: 10, ease: 'none' }, "frame02+=0");
    heroItemsTL.fromTo(item02, 1, { scale: 0, transformOrigin: 'center' }, { transformOrigin: 'center', scale: 1, ease: Elastic.easeOut.config(0.8, 1) }, "frame02+=1.4");
    //heroItemsTL.fromTo(item02.icon, 1, { scale: 0, transformOrigin: 'center' }, { transformOrigin: 'center', scale: 1, ease: Elastic.easeOut.config(0.8, 1) }, "frame02+=1.5");
    heroItemsTL.to(item02, 1, { scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) }, "frame02+=4");
    
    heroItemsTL.add("frame03", "frame02+=1.5");
    heroItemsTL.fromTo(item03, 5, { x: -20, y: 0, rotation: -20, transformOrigin: 'center', }, { transformOrigin: 'center', x: 130, y: -15, rotation: 10, ease: 'none' }, "frame03+=0");
    heroItemsTL.fromTo(item03, 1, { scale: 0, transformOrigin: 'center' }, { transformOrigin: 'center', scale: 1, ease: Elastic.easeOut.config(0.8, 1) }, "frame03+=1.4");
    //heroItemsTL.to(item03.icon, 1, { transformOrigin: 'center', scale: 1, ease: Elastic.easeOut.config(0.8, 1) }, "frame03+=1.5");
    heroItemsTL.to(item03, 1, { scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) }, "frame03+=4");
    
    heroItemsTL.add("frame04", "frame03+=1.5");
    heroItemsTL.fromTo(item04, 5, { x: -20, y: 0, rotation: -10, transformOrigin: 'center', }, { transformOrigin: 'center', x: 120, y: 30, rotation: 10, ease: 'none' }, "frame04+=0");
    heroItemsTL.fromTo(item04, 1, { scale: 0, transformOrigin: 'center' }, { transformOrigin: 'center', scale: 1, ease: Elastic.easeOut.config(0.8, 1) }, "frame04+=1.4");
    //heroItemsTL.fromTo(item04.icon, 1, { scale: 0, transformOrigin: 'center' }, { transformOrigin: 'center', scale: 1, ease: Elastic.easeOut.config(0.8, 1) }, "frame04+=1.5");
    heroItemsTL.to(item04, 1, { scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) }, "frame04+=4");

    heroItemsTL.add("frame05", "frame04+=1.5");
    heroItemsTL.fromTo(item01, 5, { x: -20, y: 0, rotation: -10, transformOrigin: 'center', }, { transformOrigin: 'center', x: 150, y: -20, rotation: 10, ease: 'none' }, "frame05+=0");
    heroItemsTL.fromTo(item01, 1, { scale: 0, transformOrigin: 'center' }, { transformOrigin: 'center', scale: 1, ease: Elastic.easeOut.config(0.8, 1) }, "frame05+=1.4");
    //heroItemsTL.fromTo(item01.icon, 1, { scale: 0, transformOrigin: 'center' }, { transformOrigin: 'center', scale: 1, ease: Elastic.easeOut.config(0.8, 1) }, "frame05+=1.5");
    heroItemsTL.to(item01, 1, { scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) }, "frame05+=4");

    heroItemsTL.add("frame06", "frame05+=1.5");
    heroItemsTL.fromTo(item02, 5, { x: -20, y: 0, rotation: -10, transformOrigin: 'center', }, { transformOrigin: 'center', x: 120, y: 20, rotation: 10, ease: 'none' }, "frame06+=0");
    heroItemsTL.fromTo(item02, 1, { scale: 0, transformOrigin: 'center' }, { transformOrigin: 'center', scale: 1, ease: Elastic.easeOut.config(0.8, 1) }, "frame06+=1.4");
    //heroItemsTL.fromTo(item02.icon, 1, { scale: 0, transformOrigin: 'center' }, { transformOrigin: 'center', scale: 1, ease: Elastic.easeOut.config(0.8, 1) }, "frame06+=1.5");
    heroItemsTL.to(item02, 1, { scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) }, "frame06+=4");

    heroItemsTL.add("frame07", "frame06+=1.5");
    heroItemsTL.fromTo(item03, 5, { x: -20, y: 0, rotation: -20, transformOrigin: 'center', }, { transformOrigin: 'center', x: 130, y: -15, rotation: 10, ease: 'none' }, "frame07+=0");
    heroItemsTL.fromTo(item03, 1, { scale: 0, transformOrigin: 'center' }, { transformOrigin: 'center', scale: 1, ease: Elastic.easeOut.config(0.8, 1) }, "frame07+=1.4");
    //heroItemsTL.fromTo(item03.icon, 1, { scale: 0, transformOrigin: 'center' }, { transformOrigin: 'center', scale: 1, ease: Elastic.easeOut.config(0.8, 1) }, "frame07+=1.5");
    heroItemsTL.to(item03, 1, { scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) }, "frame07+=4");

    heroItemsTL.add("frame08", "frame07+=1.5");
    heroItemsTL.fromTo(item04, 5, { x: -20, y: 0, rotation: -10, transformOrigin: 'center', }, { transformOrigin: 'center', x: 120, y: 30, rotation: 10, ease: 'none' }, "frame08+=0");
    heroItemsTL.fromTo(item04, 1, { scale: 0, transformOrigin: 'center' }, { transformOrigin: 'center', scale: 1, ease: Elastic.easeOut.config(0.8, 1) }, "frame08+=1.4");
    //heroItemsTL.fromTo(item04.icon, 1, { scale: 0, transformOrigin: 'center' }, { transformOrigin: 'center', scale: 1, ease: Elastic.easeOut.config(0.8, 1) }, "frame08+=1.5");
    heroItemsTL.to(item04, 1, { scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) }, "frame08+=4");

    heroItemsTL.add("frame09", "frame08+=1.5");
    heroItemsTL.fromTo(item01, 5, { x: -20, y: 0, rotation: -10, transformOrigin: 'center', }, { transformOrigin: 'center', x: 150, y: -20, rotation: 10, ease: 'none' }, "frame09+=0");
    heroItemsTL.fromTo(item01, 1, { scale: 0, transformOrigin: 'center' }, { transformOrigin: 'center', scale: 1, ease: Elastic.easeOut.config(0.8, 1) }, "frame09+=1.4");
    //heroItemsTL.fromTo(item01.icon, 1, { scale: 0, transformOrigin: 'center' }, { transformOrigin: 'center', scale: 1, ease: Elastic.easeOut.config(0.8, 1) }, "frame09+=1.5");
    heroItemsTL.to(item01, 1, { scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) }, "frame09+=4");

    heroItemsTL.add("frame10", "frame09+=1.5");
    heroItemsTL.fromTo(item02, 5, { x: -20, y: 0, rotation: -10, transformOrigin: 'center', }, { transformOrigin: 'center', x: 120, y: 20, rotation: 10, ease: 'none' }, "frame10+=0");
    heroItemsTL.fromTo(item02, 1, { scale: 0, transformOrigin: 'center' }, { transformOrigin: 'center', scale: 1, ease: Elastic.easeOut.config(0.8, 1) }, "frame10+=1.4");
    //heroItemsTL.fromTo(item02.icon, 1, { scale: 0, transformOrigin: 'center' }, { transformOrigin: 'center', scale: 1, ease: Elastic.easeOut.config(0.8, 1) }, "frame10+=1.5");
    heroItemsTL.to(item02, 1, { scale: 0, transformOrigin: 'center', ease: Elastic.easeIn.config(0.8, 1) }, "frame10+=4");

    heroItemsTL.add( ()=>{ heroItemsTL.seek("frame07+=0"); } , "frame10+=1.5" );

    
    heroIconConveyorTL.play();
    heroLogosTL.timeScale(0.8);
    heroLogosTL.play( "frame02+=0");
    heroItemsTL.play( "frame02+=0");
}

function initHighlightsBlock() {
    const highlightButtons = queryAll('.highlight-button');
    const highlightsBlock = query('.highlights-block');

    // Store heights for responsiveness
    function getHeights(button) {
        const title = button.querySelector('h3');
        const copy = button.querySelector('p');
        const collapsed = title.offsetHeight + parseInt(window.getComputedStyle(title).marginTop) + parseInt(window.getComputedStyle(title).marginBottom) + parseInt(window.getComputedStyle(title).paddingTop) + parseInt(window.getComputedStyle(title).paddingBottom);
        const expanded = collapsed + (copy.offsetHeight);
        
        return { collapsed, expanded };
    }

    // Store heights for each button
    highlightButtons.forEach((button, i) => {
        button._heights = getHeights(button);
        button.setAttribute('data-index', i);
    });

    // Responsive: recalc heights on resize
    function onHighlightsWindowResize() {
        highlightButtons.forEach(button => {
            button._heights = getHeights(button);
        });
        // Re-apply correct height and copy visibility to all buttons
        highlightButtons.forEach(button => {
            const copy = button.querySelector('p');
            if (button.classList.contains('active')) {
                gsap.set(button, { height: button._heights.expanded });
                gsap.set(copy, { autoAlpha: 1 });
            } else {
                gsap.set(button, { height: button._heights.collapsed });
                gsap.set(copy, { autoAlpha: 0 });
            }
        });

        const highlightImages = queryAll('.highlight-image');
        const highlightImagesContainer = query('.highlight-images-container');
        // Find the largest highlight image
        if (highlightImagesContainer && highlightImages.length > 0) {
            let maxHeight = 0;
            let maxWidth = 0;
            
            highlightImages.forEach(img => {
                if (img.offsetHeight > maxHeight) maxHeight = img.offsetHeight;
                if (img.offsetWidth > maxWidth) maxWidth = img.offsetWidth;
            });
            
            // Set container dimensions to match largest image
            gsap.set(highlightImagesContainer, { 
                height: maxHeight, 
                width: maxWidth 
            });
        }
    };

    window.addEventListener('resize', onHighlightsWindowResize);

    highlightButtons.forEach(button => {
        button.addEventListener('click', () => {
            const index = button.getAttribute('data-index');
            openHighlight(index);
        });
    });

    // Initialize ScrollTrigger for highlights
    if (highlightsBlock && highlightButtons.length) {
        // Calculate the total duration based on number of highlights
        // Each highlight gets 2 seconds, plus 2 seconds for the last one before unpinning
        const totalDuration = (highlightButtons.length * 1.5) + 1.5;
        
        // Create the ScrollTrigger for non-mobile screens only
        if (window.matchMedia('(min-width: 576px)').matches) {
            ScrollTrigger.create({
                trigger: highlightsBlock,
                pin: true,
                pinSpacing: true,
                start: "top top",
                end: `+=${totalDuration * 100}%`, // Make the scroll distance proportional to duration
                scrub: true,
                onUpdate: (self) => {
                    // Calculate which highlight should be active based on scroll progress
                    const progress = self.progress;
                    const sectionDuration = 1 / (highlightButtons.length + 1); // +1 for the unpinning section
                    const currentSection = Math.floor(progress / sectionDuration);
                    // Only trigger openHighlight if we're in a valid highlight section
                    if (currentSection < highlightButtons.length) {
                        openHighlight(currentSection);
                    }
                }
            });
        }
    }

    // Initialize the first highlight
    if (highlightButtons.length) {
        openHighlight(0);
        onHighlightsWindowResize();
    }
}

function openHighlight(index) {
    if (index == currHighlight ) return;

    currHighlight = index;
    const highlightButtons = queryAll('.highlight-button');
    const highlightImages = queryAll('.highlight-image');

    highlightButtons.forEach((button, i) => {
        const copy = button.querySelector('p');
        if (parseInt(index) === i) {
            // Set active class only for selected
            highlightButtons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');
            // Animate expand
            gsap.to(button, { height: button._heights.expanded, duration:1, ease:Expo.easeInOut });
            gsap.to(copy, { autoAlpha: 1, duration:1, ease:Expo.easeInOut });
        } else {
            button.classList.remove('active');
            // Animate collapse
            gsap.to(copy, { autoAlpha: 0, duration: 1, ease:Expo.easeInOut });
            gsap.to(button, { height: button._heights.collapsed, duration:1, ease:Expo.easeInOut });
        }
    });

    highlightImages.forEach((image, i) => {
        if (parseInt(index) === i) {
            gsap.to(image, { overwrite:true , autoAlpha: 1, duration: 1 });
        } else {
            gsap.to(image, { overwrite:true , autoAlpha: 0, duration: 0.5 });
        }
    });
}

function initSalesBanner() {
    const footer = query('footer.site-footer');
    const salesBanner = query('.sales-banner');

    gsap.set(footer, { paddingBottom: salesBanner.offsetHeight });
}

function initLeadershipBlock() {
    const leadershipBlocks = queryAll('.leadership-block');

    leadershipBlocks.forEach(block => {
        const members = block.querySelectorAll('.leadership-member');

        members.forEach(member => {
            const memberModal = member.querySelector('.member-modal');
            member.addEventListener('click', () => {
                openModal(memberModal.cloneNode(true).innerHTML, 'member-modal');
            });
        });
    });
}

function openModal( content , className ) {
    const modal = query('.modal-overlay');
    const modalContainer = query('.modal-container');
    const modalContent = query('.modal-content');
    modalContainer.classList.add(className);
    modalContent.innerHTML = content;
    modal.classList.add('active');
    gsap.fromTo( modal, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.2 } );
}

function closeModal() {
    const modal = query('.modal-overlay');
    const modalContainer = query('.modal-container');
    modalContainer.classList.remove();
    modalContainer.classList.add('modal-container');
    
    gsap.to( modal, { autoAlpha: 0, duration: 0.25 , onComplete: () => {
        modal.classList.remove('active');
    }} );
}

/*** init menu */
function initMenu() {
    const mobileMenuTrigger = query('.mobile-menu-trigger');
    const mobileMenu = query('.mobile-menu');
    const siteHeader = query('.site-header');
    
    mobileMenuTrigger.addEventListener('click', () => {
        siteHeader.classList.toggle('expanded');
    });

    window.addEventListener('resize', () => {
        siteHeader.classList.remove('expanded');
    });

    document.addEventListener('click', (e) => {
        if (!mobileMenuTrigger.contains(e.target) && !mobileMenu.contains(e.target)) {
            siteHeader.classList.remove('expanded');
        }
    });

    gsap.set(siteHeader, { y: 0 });

    let lastScrollTop = 0;
    window.addEventListener('scroll', () => {
        
        if( siteHeader.classList.contains('expanded') ) return;

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        //console.log('scroll' , scrollTop , lastScrollTop);
        if (scrollTop > 200 && (scrollTop > lastScrollTop)) {
            if(!siteHeader.hidden) gsap.to(siteHeader, { overwrite:true , y: -siteHeader.offsetHeight, duration: 0.5, ease: Expo.easeIn });
            siteHeader.hidden = true;
        } else {
            if(siteHeader.hidden) gsap.to(siteHeader, { overwrite:true , y: 0, duration: 0.5, ease: Expo.easeOut });
            siteHeader.hidden = false;
        }
        lastScrollTop = scrollTop;
    });
}
